<template>
  <div>
    <ul
      v-if="mappedValue.length > 0"
      class="list-disc ml-[10px] mb-[6px] p-[4px]"
    >
      <li
        v-for="item in mappedValue"
        :key="item.id"
      >
        <span
          class="flex items-center justify-between gap-[8px]"
        >
          {{ item.name || '-' }}
          <span
            v-if="item.layer"
            class="font-medium"
          >x{{ item.layer }}</span>
        </span>
      </li>
    </ul>
    <p
      v-else
    >-</p>

    <b-button
      v-if="!$route.params.order_data_id"
      size="sm"
      variant="ghost"
      class="w-full !text-left !px-[4px] !font-normal !text-[#F95031] hover:!text-[#F95031]/80"
      @click="handleEditPacking"
    >
      <span class="k-add text-[14px]" />
      Bahan Packing
    </b-button>
    <ModalPackagingSettings
      v-if="fetcher"
      ref="modalPackagingSettings"
      :fetcher="fetcher"
      @on-save="handleSavePacking"
    />
  </div>
</template>

<script>
import ModalPackagingSettings from '@/views/pages/kompack/packing/components/ModalPackingSettings.vue'
import createRecalculation from '@/views/pages/kompack/packing/composables/useRecalculation'

export default {
  name: 'PackingSelection',
  components: {
    ModalPackagingSettings,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fetcher: {
      type: Object,
      required: true,
      default: () => undefined,
    },
    data: {
      type: Object,
      required: true,
      default: () => undefined,
    },
  },
  data() {
    return {
      localPackings: [],
    }
  },
  computed: {
    mappedValue() {
      return this.localPackings.map(item => ({
        id: item.option_id,
        name: item.packing_name,
        layer: item.packing_layer,
      }))
    },
    mappedPayload() {
      return {
        warehouse_id: this.$route.params.warehouse_id,
        total_order: 1,
        products: this.data.product?.map(item => ({
          product_id: item.product_id,
          total_item: item.qty,
          is_product_bonus: item.is_product_bonus === 1,
          is_bundling: item.is_bundling !== 0,
          storage_type: item.storage_type,
          bundle_components: item.bundle_component?.map(variant => ({
            product_id: variant.product_id,
            qty: variant.qty,
            is_product_bonus: variant.is_product_bonus === 1,
            storage_type: variant.storage_type,
          })),
        })),
      }
    },
  },
  watch: {
    value: {
      handler(newValue) {
        this.localPackings = Array.isArray(newValue) ? newValue : []
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.recalculation = createRecalculation(this)
    this.payload = {
      warehouse_id: this.$route.params.warehouse_id,
      total_order: 1,
    }
  },
  methods: {
    handleEditPacking(e) {
      e.preventDefault()
      this.$refs.modalPackagingSettings.show({
        position: 0,
        packings: this.mappedValue,
        beforeSave: this.handleBeforeSavePacking,
      })
    },
    handleSavePacking({ data }) {
      this.$emit('there-is-change-fulfillment-cost', true)
      const newValue = data?.map(item => ({
        option_id: item.id,
        packing_name: item.name,
        packing_layer: Number(item.layer) || 0,
      }))
      this.localPackings = newValue || []
      this.$emit('input', newValue)
    },
    async handleBeforeSavePacking({ data }) {
      const result = await this.recalculateFulfillment(data || [])

      if (!result?.success) {
        throw new Error(result?.message || 'Gagal melakukan rekalkulasi. Silakan coba lagi')
      }

      this.data.fulfillment_fee = result.data.fulfillment_cost
    },
    async recalculateFulfillment(data) {
      const packings = data.map(item => ({
        id: item.id,
        total_layer: Number(item.layer) || 0,
      }))

      const body = {
        ...this.mappedPayload,
        packings,
      }

      try {
        const result = await this.fetchRecalculateFulfillment(body)
        return {
          success: true,
          data: result,
        }
      } catch (error) {
        return {
          success: false,
          message: 'Gagal melakukan rekalkulasi. Silakan coba lagi',
        }
      }
    },
    async fetchRecalculateFulfillment(body) {
      try {
        const response = await this.$http_new.post('/komship/api/v2/orders/recalculate-fulfillment', body)
        return response.data.data
      } catch {
        return null
      }
    },
    mapPackingMaterialToValue(material) {
      return {
        option_id: material.id,
        packing_name: material.name,
        packing_layer: Number(material.layer) || 0,
      }
    },
  },
}
</script>
